import { inject, injectable } from "@launchtray/tsyringe-async";
import { InjectableInterfaces } from "../../../../composition/InjectableInterfaces";
import { IGameDistributionSdk } from "../../../../gamedistribution/interfaces/IGameDistributionSdk";

@injectable()
export class LosePopupController {
    public constructor(
        @inject(InjectableInterfaces.IGameDistributionSdk) private readonly gdSdk: IGameDistributionSdk
    ) { }

    public async showAd(): Promise<boolean> {
        return await this.gdSdk.showRewardedAd();
    }

    public async showMidrollAd(): Promise<void> {
        return await this.gdSdk.showMidrollAd();
    }
}
